const validate = require("validate.js");

/**
 * Fetch constraint based on constraint name
 * When creating constraint the constraint to check MUST containt 'specificConstraint' first at a start point
 * @param {String} constraintName - Name of the constraint to fetch
 * @return {Object} - Returns constraint for validator
 */
const getConstraint = (constraintName) => {
	let validator = validate;
	const constraints = { // Constraint must only contains one constraint per type
		nameConstraint: { // Name is present
			specificConstraint: {
				presence: {allowEmpty: false,
					message: "ne peut pas être vide"
				}
			}
		},
		flexibleConstraint: { // Name is present

		},
		siretConstraint: { // SIRET Length validation
			specificConstraint: {
				format: {
					pattern: /^[0-9]{9,14}$/,
					message: "^Ceci n'est pas un numéro SIRET valide."
				}
			}
		},
		commercial_idConstraint: { // Commercial_id is present
			specificConstraint: {
				presence: true
			}
		},
		commentaryConstraint: {
			specificConstraint: {
				format: {
					pattern: /^.{0,500}$/,
					message: "^500 caractères au maximum."
				}
			}
		},
		originConstraint: { // Origin is present
			specificConstraint: {
				presence: true
			}
		},
		websiteConstraint: { // Website is present
			specificConstraint: {
				presence: true,
				url: {
					pattern: /^https?:\/\/(?!.*:\/\/)\S+/,
					message: "^Ceci n'est pas une URL valide (http(s)://domain.com)",
				}
			}
		},
		websiteOptionalConstraint: { // Website is present
			specificConstraint: {
				url: {
					pattern: /^https?:\/\/(?!.*:\/\/)\S+/,
					message: "^Ceci n'est pas une URL valide (http(s)://domain.com)",
				}
			}
		},
		linkConstraint: { // Website is present
			specificConstraint: {
				url: {
					pattern: /^(https|http|ftp)?:\/\/(?!.*:\/\/)\S+/,
					message: "^Ceci n'est pas une URL valide (http | https | ftp://domain.com)",
				}
			}
		},
		domaineConstraint: { // Website is present
			specificConstraint: {
				presence: true,
				format: {
					pattern: /^[a-z0-9]+\w*\.(?!.*?[._]{2})\S*[a-z]{2,}$/,
					message: "^Ceci n'est pas un domaine valide.",
				}
			}
		},
		activity_domainConstraint: { // Website is present
			specificConstraint: {
				presence: true,
			}
		},
		is_ecommerceConstraint: { // Is_ecommerce is present
			specificConstraint: {
				presence: true
			}
		},
		statusConstraint: { // Status is present
			specificConstraint: {
				presence: true
			}
		},
		emailConstraint: { // Is email
			specificConstraint: {
				presence: {
					message: function(value) {
						return validator.format("^L'email ne peut être vide.", {
							email: value
						});
					}
				},
				email: {
					pattern: /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+)*.[A-Za-z0-9]+$/,
					message: "^Email invalide."
				}
			}
		},
		civilityConstraint: { // Civility is valid
			specificConstraint: {
				presence: {
					message: function(value) {
						return validator.format("^La civilité ne peut être vide.", {
							civility: value
						});
					}
				}
			}
		},
		firstnameConstraint: { // Firstname is valid
			specificConstraint: {
				presence: {
					message: function(value) {
						return validator.format("^Le prénom ne peut être vide.", {
							firstname: value
						});
					}
				}
			}
		},
		lastnameConstraint: { // Lastname is valid
			specificConstraint: {
				presence: {
					message: function(value) {
						return validator.format("^Le nom ne peut être vide.", {
							lastname: value
						});
					}
				}
			}
		},
		typeConstraint: { // Type is valid
			specificConstraint: {
				presence: {
					message: function(value) {
						return validator.format("^Le type ne peut être vide.", {
							type: value
						});
					}
				}
			}
		},
		phoneConstraint: { // Phone is valid
			specificConstraint: {
				format: {
					pattern: /^[0-9\s]+$/,
					message: "^Seulement chiffres et espaces autorisés."
				}
			}
		},
		hasAccessConstraint: { // hasAccess is valid
			specificConstraint: {
				presence: true
			}
		},
		isNumberConstraint: {
			specificConstraint: {
				format: {
					pattern: /^\d+$/,
					message: "^Ce champ doit être un nombre."
				}
			}
		},
		noNumberConstraint: { // country/city is valid
			specificConstraint: {
				format: {
					pattern: /^\D+$/,
					message: function(value) {
						return validator.format("^Votre saisie n'est pas valide.", {
							noNumber: value
						});
					}
				}
			}
		},
		codePostalConstraint: { // code postal is valid
			specificConstraint: {
				format: {
					pattern: /^[0-9]{0,11}$/,
					message: "^Votre saisie n'est pas valide, pour les CP qui contiennent autre chose que des chiffres ou qui excèdent 11 chiffres, doivent être saisis dans le champ \"Complément d'adresse\"."
				}
			}
		},
		priceConstraint: {
			specificConstraint: {
				format: {
					pattern: /^\d+(\.\d{1,2}|\,\d{1,2})?$/,
					message: "^Ce champ doit être un nombre."
				}
			}
		},
		rnameConstraint: {
			specificConstraint: {
				format: {
					pattern: /^.{1,}$/,
					message: "^Ce champ ne peut être vide."
				}
			}
		},
	};
	return constraints[constraintName];
};

/**
 * Check value based on selected specificConstraint from constraint
 * @param {String} valueToCheck - Value to test
 * @param {Object} constraint - Constraint object containing specific constraints
 * @return {Object} Return undefined if valid else return an object with error message
 */
const validateValue = (valueToCheck, constraint) => {
	let validator = validate;
	return validator({specificConstraint: valueToCheck}, constraint);
};

export default {
	methods: {
		/**
		 * Handle validator choice based on passed constraintName
		 * @param {String} value - Value to be validated
		 * @param {String} constraintName - Name of the selected constraint to be fetch in constraints list
		 * @return {Object} - Returns undefined if valid else returns object with error message
		 */
		validatorHandler: (value, constraintName) => {
			let constraint = getConstraint(constraintName);
			console.log(constraint);
			return validateValue(value, constraint);
		},
		/**
		 * Checks if field is valid based on constraints
		 * @param value - Value to be tested
		 * @param fieldObject - Validator Object containing fields for success/danger bools and texts
		 */
		checkHandler(value, fieldObject){
			if(value != "" && value != null){
				let valueValid = this.validatorHandler(value, fieldObject.constraintName);
				if(valueValid === undefined){
					fieldObject.valid = true;
					fieldObject.notValid = false;
					fieldObject.validText = "OK";
					fieldObject.errText = "";
				}
				else{
					fieldObject.valid = false;
					fieldObject.notValid = true;
					fieldObject.validText = "";
					fieldObject.errText = valueValid.specificConstraint[0];
				}
			}
			else{
				fieldObject.valid = false;
				fieldObject.notValid = false;
				fieldObject.validText = "";
				fieldObject.errText = "";
			}
			return fieldObject;
		},
	}
};